import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session.js';

export function UserMenu() {
  const { t } = useTranslation();
  const { user, signOut } = useSession();
  const navigate = useNavigate();

  if (!user) return null;

  const onSignOut = () => {
    signOut();
    navigate('/login', { replace: true });
  };

  const initials = user.name
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const fnRoleSummary =
    user.function_roles.length === 0
      ? null
      : user.function_roles
          .map((r) =>
            r.scope_segment
              ? `${t(`rollen.${r.role}`)} (${r.scope_segment})`
              : t(`rollen.${r.role}`),
          )
          .join(' · ');

  const roleText = fnRoleSummary ?? (user.is_admin ? t('common.admin') : t('common.viewer'));

  return (
    <div className="flex items-center gap-3">
      <div className="flex flex-col text-right leading-tight">
        <span className="text-sm font-medium text-ink-900">{user.name}</span>
        <Link
          to="/hilfe#rolle"
          title={`${t('hilfe.rolle.menue')}: ${roleText}`}
          aria-label={`${t('hilfe.rolle.menue')}: ${roleText}`}
          className="block max-w-[16rem] truncate text-[11px] text-ink-500 hover:text-ink-900 hover:underline"
        >
          {roleText}
          {user.is_test_user && <span className="ml-1 text-brand-orange">· test</span>}
          {user.mode === 'dev-stub' && <span className="ml-1 text-brand-orange">· dev</span>}
        </Link>
      </div>
      <div className="w-8 h-8 rounded-full bg-brand-orange text-white text-xs font-semibold flex items-center justify-center">
        {initials}
      </div>
      <button
        type="button"
        onClick={onSignOut}
        className="text-xs text-ink-500 hover:text-ink-900 px-2 py-1 rounded hover:bg-ink-100 transition-colors"
      >
        {t('v2.nav.sign_out')}
      </button>
    </div>
  );
}
